import React from 'react';
import { CheckCircle2, Circle, Clock } from 'lucide-react';
import { CustomerTrackingEvent, OrderStatus } from '../../lib/types';
import { getOrderStatusSteps, getStatusLabel, formatRelativeTime, cn } from '../../lib/utils';
interface StatusTimelineProps {
  currentStatus: OrderStatus;
  events: CustomerTrackingEvent[];
  restaurantId?: string;
}
export function StatusTimeline({
  currentStatus,
  events,
  restaurantId
}: StatusTimelineProps) {
  const steps = getOrderStatusSteps(restaurantId);
  // Find the index of the current status in the defined steps
  const currentIndex = steps.indexOf(currentStatus);
  // If cancelled, show a specific cancelled state
  if (currentStatus === 'cancelled') {
    return <div className="bg-red-50 border border-red-100 rounded-2xl p-6 text-center" data-id="element-944">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-945">
          <Circle className="w-8 h-8 text-red-500" data-id="element-946" />
        </div>
        <h3 className="text-xl font-bold text-red-900 mb-2" data-id="element-947">
          Pedido Cancelado
        </h3>
        <p className="text-red-700" data-id="element-948">
          Lo sentimos, este pedido ha sido cancelado. Si tienes dudas, por favor
          contacta al restaurante.
        </p>
      </div>;
  }
  return <div className="relative pl-4 sm:pl-8 py-4" data-id="element-949">
      {/* Vertical Line */}
      <div className="absolute left-7 sm:left-11 top-8 bottom-8 w-0.5 bg-gray-200" data-id="element-950" />

      <div className="space-y-8 relative" data-id="element-951">
        {steps.map((step, index) => {
        const isCompleted = index <= currentIndex;
        const isCurrent = index === currentIndex;
        // Find if there's an event for this step to show timestamp
        const event = events.find(e => e.status === step);
        return <div key={step} className={cn('flex items-start gap-4 sm:gap-6', !isCompleted && 'opacity-50')} data-id="element-952">
              {/* Icon */}
              <div className="relative z-10 shrink-0 mt-1" data-id="element-953">
                {isCompleted ? <div className={cn('w-7 h-7 rounded-full flex items-center justify-center bg-white', isCurrent ? 'text-brand-amber' : 'text-emerald-500')} data-id="element-954">
                    <CheckCircle2 className="w-7 h-7" data-id="element-955" />
                  </div> : <div className="w-7 h-7 rounded-full bg-white border-2 border-gray-300 flex items-center justify-center" data-id="element-956">
                    <Circle className="w-3 h-3 text-gray-300 fill-current" data-id="element-957" />
                  </div>}
              </div>

              {/* Content */}
              <div className="flex-1 pb-2" data-id="element-958">
                <h4 className={cn('text-lg font-bold', isCurrent ? 'text-brand-amber' : 'text-gray-900')} data-id="element-959">
                  {getStatusLabel(step, restaurantId)}
                </h4>

                {event && <div className="flex items-center gap-1.5 text-sm text-gray-500 mt-1" data-id="element-960">
                    <Clock className="w-3.5 h-3.5" data-id="element-961" />
                    {formatRelativeTime(event.created_at)}
                  </div>}

                {event?.message && <p className="text-gray-600 text-sm mt-2 bg-gray-50 p-3 rounded-lg border border-gray-100" data-id="element-962">
                    {event.message}
                  </p>}
              </div>
            </div>;
      })}
      </div>
    </div>;
}